import type { FaireProductEntity } from "../../entity_types/product";

export const p_xe9n25w5cc: FaireProductEntity = {
  token: "p_xe9n25w5cc",
  type: "product",
  name: "Solitaire Moissanite Engagement Ring in 925 Sterling Silver",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl: "https://cdn.faire.com/fastly/f2e769296411e2e1e90e14963333a4ce84a1bed1da231c470948e3937a941fd4.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f250f2e7bdd6a85639f16944abfacea74dca9061c5991ce47eee88fc30dc28a7.jpeg",
    "https://cdn.faire.com/fastly/a5054b2ec2db3902d381b564a644dd607879de9c6d81028b6e62ca5cd7e871b1.png",
    "https://cdn.faire.com/fastly/7dd73389929598cd39008b33d720f613b296e8aa51663322d213af1cb9ed26ad.jpeg",
    "https://cdn.faire.com/fastly/2bd2d9e795395651861264dc6f582ebe74a77b1402b9fc0c7c2ee2375ede0e7a.png",
    "https://cdn.faire.com/fastly/6e0411c12acc160c05e8343b7d7023f5724141fdf12ce56e9642620329b4eb66.jpeg",
    "https://cdn.faire.com/fastly/06ea5a44556fcd896681c6992c4c1faab434aef52d271ee32f3dea98b9fc1c2b.png",
    "https://cdn.faire.com/fastly/04bbbb6145f3bbef7b6803ce6a8ed0b18780694724067a3e695c38023f05f867.png"
  ],
  priceDollars: 33.91,
  description: "Description & Details\n\nWhere diamonds symbolize tradition and stability, moissanite is a metaphor for youthfulness, effervescence and the journey of our endeavors.\n\n• Material: Solid 925 Sterling Silver ∙ Certified Moissanite (Color D, VVS1)\n• Finish: Hypoallergenic ∙ 18k Gold (Au 750) Plating\n• Dimensions: 0.5 - 5 ct, Color D, VVS1 Moissanite, US size 4 1/2 - 9 available\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 59.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:28.307Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
